import { useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { TranslateText } from "../../../utils/translation";

const Header = () => {
  const { inActiveRooms } = useSelector((store) => store.rooms);

  return (
    <header className="shadow-housekeeping-header h-[68px] w-full flex items-center justify-between pl-[30px] pr-[50px] bg-surface">
      <p className="w-[14.6%] font-[600] text-[22px] leading-[33px] text-fg-secondary">
        <TranslateText textKey={"housekeeping"} namespace="housekeeping" />
      </p>
      <div className="w-[64.54%] flex items-center justify-between pl-[31%]">
        
        <div className="flex items-center gap-[38px]">
          <Link
  to="/dashboard/house-keeping/out-of-order"
  className="flex items-center gap-[16px] cursor-pointer hover:bg-danger-light p-1 rounded"
>
  <div>
    <p className="font-[300] text-[10px] leading-[15px] text-fg-muted">
      <TranslateText textKey="out_of_order" namespace="housekeeping" />
    </p>
    <p className="font-[500] text-[14px] leading-[21px] text-danger">
      {inActiveRooms?.length || 0}{" "}
      <TranslateText textKey="rooms" namespace="housekeeping" />
    </p>
  </div>
  {/* optional arrow icon */}
  <svg
    className="w-4 h-4 text-danger"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M9 5l7 7-7 7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
</Link>

          
        </div>
        
      </div>
    </header>
  );
};
export default Header;
